module.exports = __webpack_public_path__ + "static/media/newskyline-product-1.48357b94.jpg";